import ApiClient from './ApiClient';

class AutomationFlowsAPI extends ApiClient {
  constructor() {
    super('automation_flows', { accountScoped: true });
  }
}

export default new AutomationFlowsAPI();
